"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const List_1 = __importDefault(require("@material-ui/core/List"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const chatListItemBuilder = __importStar(require("./ChatListItemBuilder"));
exports.default = react_1.default.memo(ChatList);
const useStyles = makeStyles_1.default((_theme) => ({
    list: {
        overflowX: "hidden",
        overflowY: "auto"
    }
}));
function ChatList() {
    var _a;
    const chatsState = react_redux_1.useSelector((state) => state.chatsState);
    const userDictionary = react_redux_1.useSelector((state) => state.usersState.userDictionary);
    const me = (_a = react_redux_1.useSelector((state) => { var _a; return (_a = state.usersState.me) === null || _a === void 0 ? void 0 : _a.userId; })) !== null && _a !== void 0 ? _a : "";
    const classes = useStyles();
    const selectedChatIndex = chatsState.selectedChatIndex;
    const chats = chatsState.chats.map((c, index) => {
        return chatListItemBuilder.build(c, userDictionary, index, selectedChatIndex, me);
    });
    return (react_1.default.createElement(List_1.default, { disablePadding: true, className: classes.list }, chats));
}
